import Reveal from 'stimulus-reveal-controller'

// Borrows Reveal controller from Stimulus, but syncs checked
// toggle targets to toggle items on connection.
export default class extends Reveal {
  static targets = ['toggle', 'item']

  connect () {
    super.connect()

    this.sync()
  }

  sync () {
    if (!this.hasToggleTarget) { return }

    const isChecked = this.toggleTarget.checked

    this.itemTargets.forEach((el) => {
      el.classList.toggle(this.hiddenClass, !isChecked)
    })
  }
}
